// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"0e41bbc4","787":"c791f8b5","921":"c79c56be"}[chunkId] + ".chunk.js";
};